import { render, staticRenderFns } from "./DataListBranches.vue?vue&type=template&id=273d01a8&scoped=true&"
import script from "./DataListBranches.vue?vue&type=script&lang=js&"
export * from "./DataListBranches.vue?vue&type=script&lang=js&"
import style0 from "./DataListBranches.vue?vue&type=style&index=0&id=273d01a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273d01a8",
  null
  
)

export default component.exports